export default {
  WP: 'Wood products',
  PM: 'Packaging materials',
  BM: 'Biomaterials',
};
